/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PageLink({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.4 3A2.6 2.6 0 0 1 4 .4h4.672a2.6 2.6 0 0 1 .221.01.604.604 0 0 1 .397.065 2.6 2.6 0 0 1 1.22.687L13.84 4.49a2.6 2.6 0 0 1 .686 1.22.597.597 0 0 1 .066.397c.006.073.009.147.009.221V13a2.6 2.6 0 0 1-2.6 2.6H9a.6.6 0 1 1 0-1.2h3a1.4 1.4 0 0 0 1.4-1.4V6.6H11A2.6 2.6 0 0 1 8.4 4V1.6H4A1.4 1.4 0 0 0 2.6 3v1a.6.6 0 1 1-1.2 0V3Zm8.2-1.048V4A1.4 1.4 0 0 0 11 5.4h2.048a1.374 1.374 0 0 0-.058-.062L9.662 2.01c-.02-.02-.041-.04-.062-.058Z" clipRule="evenodd" /><path fill="currentColor" d="M5.9 9.375a.6.6 0 0 0 1.2 0V8.25a2.85 2.85 0 1 0-5.7 0v1.125a.6.6 0 0 0 1.2 0V8.25a1.65 1.65 0 1 1 3.3 0v1.125Z" /><path fill="currentColor" d="M4.25 7.65a.6.6 0 0 1 .6.6v4.5a.6.6 0 1 1-1.2 0v-4.5a.6.6 0 0 1 .6-.6Z" /><path fill="currentColor" d="M2 11.025a.6.6 0 0 1 .6.6v1.125a1.65 1.65 0 1 0 3.3 0v-1.125a.6.6 0 1 1 1.2 0v1.125a2.85 2.85 0 0 1-5.7 0v-1.125a.6.6 0 0 1 .6-.6Z" /></svg>;
}
;